import React, { useState, useEffect } from 'react';

// Hauptkomponente für das Dashboard
export default function App() {
  const [stats, setStats] = useState({ opened: 2521, closed: 1251, staff: 61, online: 35 });

  // Hier später die echten Daten vom Bot laden
  useEffect(() => {
    // fetch('DEINE_CLOUDFLARE_TUNNEL_URL/api/stats').then(...)
  }, []);

  return (
    <div style={{ display: 'flex', backgroundColor: '#0b0b0e', minHeight: '100vh', color: '#e0e0e0', fontFamily: 'Inter, sans-serif' }}>
      
      {/* SIDEBAR (Links) */}
      <div style={{ width: '260px', backgroundColor: '#121217', padding: '20px', borderRight: '1px solid #222' }}>
        <div style={{ padding: '15px', background: 'linear-gradient(135deg, #1f1f27 0%, #15151a 100%)', borderRadius: '12px', marginBottom: '30px', border: '1px solid #333', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>Lost's Server</span>
          <span style={{ color: '#c9a050' }}>›</span>
        </div>
        <div style={{ color: '#555', fontSize: '11px', fontWeight: 'bold', marginBottom: '15px', letterSpacing: '1px' }}>MENU</div>
        <ul style={{ listStyle: 'none', padding: 0 }}>
          <li style={{ padding: '12px', color: '#888', cursor: 'pointer' }}>Home</li>
          <li style={{ padding: '12px', color: '#888', cursor: 'pointer' }}>Panels</li>
          <li style={{ padding: '12px', backgroundColor: '#1a1a20', color: '#c9a050', borderRadius: '8px', marginBottom: '5px' }}>Statistics</li>
          <li style={{ padding: '12px', color: '#888', cursor: 'pointer' }}>Settings</li>
        </ul>
      </div>

      {/* MAIN CONTENT (Rechts) */}
      <div style={{ flex: 1, padding: '30px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '20px' }}>
          
          {/* Karte: Server Tickets */}
          <div style={{ backgroundColor: '#121217', padding: '20px', borderRadius: '16px', border: '1px solid #222' }}>
            <h4 style={{ fontSize: '13px', color: '#888', marginBottom: '20px' }}>Server Tickets</h4>
            <div style={{ height: '150px', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
               {/* Simulierter Donut Chart */}
               <div style={{ width: '100px', height: '100px', borderRadius: '50%', border: '12px solid #6b21ff', borderTopColor: '#ff2153' }}></div>
               <div style={{ position: 'absolute', textAlign: 'center', fontSize: '12px' }}>
                  <div style={{ color: '#ff2153' }}>■ {stats.opened}</div>
                  <div style={{ color: '#6b21ff' }}>■ {stats.closed}</div>
               </div>
            </div>
          </div>

          {/* Karte: Staff */}
          <div style={{ backgroundColor: '#121217', padding: '20px', borderRadius: '16px', border: '1px solid #222' }}>
            <h4 style={{ fontSize: '13px', color: '#888', marginBottom: '20px' }}>Staff</h4>
            <div style={{ marginBottom: '15px', backgroundColor: '#1a1a21', padding: '15px', borderRadius: '10px' }}>
              <span style={{ fontSize: '12px', color: '#666' }}>Total Staff Members</span>
              <div style={{ fontSize: '20px', fontWeight: 'bold' }}>{stats.staff}</div>
            </div>
            <div style={{ backgroundColor: '#1a1a21', padding: '15px', borderRadius: '10px' }}>
              <span style={{ fontSize: '12px', color: '#666' }}>Online Staff Members</span>
              <div style={{ fontSize: '20px', fontWeight: 'bold' }}>{stats.online}</div>
            </div>
          </div>

          {/* Karte: Ticket Categories */}
          <div style={{ backgroundColor: '#121217', padding: '20px', borderRadius: '16px', border: '1px solid #222' }}>
            <h4 style={{ fontSize: '13px', color: '#888', marginBottom: '20px' }}>Ticket Categories</h4>
            {/* Hier käme der bunte Donut aus deinem Bild hin */}
            <div style={{ textAlign: 'center', color: '#c9a050', marginTop: '40px', fontSize: '30px' }}>4</div>
          </div>

        </div>
      </div>
    </div>
  );
}